import notify from "devextreme/ui/notify";

export class AppNotification {
    static success(message: string) {
        notify({
            message: message,
            width: 500,
            type: "success"
        }, {
            direction: "down-push",
            position: "top right"
        })
    }

    static error(message: string) {
        notify({
            message: message,
            width: 500,
            type: "error"
        }, {
            direction: "down-push",
            position: "top right"
        })
    }
}